import {defineMessages} from 'react-intl';

export default defineMessages({
  startNow: {
    defaultMessage: 'Start now',
    id: 'CourseDetailPage.MenuBar.BuyButton.StartNow',
  },
});
